import actions from './actions';
import mutations from './mutations';

const state = {
    items: []
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};